/*
* This hook automatically dismisses flash messages after a time.
* Mousing over the flash resets the timer.
*/

const dismissAfter = 8_000

export default {
  mounted() {
    let hide = () => liveSocket.execJS(this.el, this.el.getAttribute("phx-click"))
    this.timer = setTimeout(() => hide(), dismissAfter)
    this.el.addEventListener("phx:hide-start", () => clearTimeout(this.timer))
    this.el.addEventListener("mouseover", () => {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => hide(), dismissAfter)
    })
  },
  destroyed() { clearTimeout(this.timer) }
}
